import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	standalone: true,
	imports: [CommonModule],
	template: `
		<div class="modal-header">
			<h5 class="modal-title">Horizontfolgetypen</h5>
			<button type="button" class="btn-close" aria-label="Schließen" (click)="activeModal.dismiss()"></button>
		</div>
		<div class="modal-body">
			<table class="table table-sm table-bordered hft-table">
				<thead>
					<tr>
						<th>Horizontfolgetyp</th>
						<th>Merkmale des Vererdungsgrades</th>
						<th>Horizontfolge</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let row of rows">
						<td><strong>{{ row.typ }}</strong></td>
						<td>{{ row.merkmal }}</td>
						<td class="horizonte-cell">{{ row.horizontfolge }}</td>
					</tr>
				</tbody>
			</table>

			<div class="klammer-hinweis mt-3">
				<div><strong>(v)</strong> = schwach entwickelt</div>
				<div><strong>[...]</strong> = nicht oder nur andeutungsweise ausgebildet oder fehlend</div>
			</div>

			<p class="text-muted small mt-3 mb-0">Quelle: SEA TeilA, Darst. A 2-6, S. 94</p>
		</div>
	`,
	styles: [`
		.hft-table {
			font-size: 0.85rem;
		}
		.hft-table th {
			text-align: center;
			vertical-align: middle;
			background: #f8f9fa;
		}
		.hft-table td {
			vertical-align: middle;
		}
		.horizonte-cell {
			font-family: monospace;
			white-space: nowrap;
		}
		.klammer-hinweis {
			font-size: 0.85rem;
			padding: 0.5rem 0.75rem;
			background: #f8f9fa;
			border-radius: 0.25rem;
		}
	`]
})
export class HorizontfolgetypenInfoModalComponent {
	activeModal = inject(NgbActiveModal);

	rows = [
		{ typ: 'Ried – Ri', merkmal: 'ohne jegliche Vererdung (wachsendes Moor)', horizontfolge: 'H' },
		{ typ: 'Fen – Fe', merkmal: 'beginnende Vererdung', horizontfolge: 'H(v) – [Hs] – H' },
		{ typ: 'Erdfen – EF', merkmal: 'deutliche Vererdung', horizontfolge: 'Hv – Hs – H' },
		{ typ: 'Mulm – Ml', merkmal: 'deutliche Vermulmung', horizontfolge: 'Hm – Hv – [Ha] – Hs – H' },
	];
}
